<template>
    <div class="servicios">
        <v-container>
            <v-list two-line>
                <v-subheader>NUESTROS SERVICIOS</v-subheader>
                <v-divider></v-divider>
                <v-list-item v-for="(item, index) in servicios_l" v-bind:key="index" :href="item.link" target="_blank">
                     <v-list-item-avatar class="mt-0 mb-0">
                        <v-img :src="domain+'/'+item.avatar"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content class="pt-0 pb-0">
                        <v-list-item-title v-html="item.title"></v-list-item-title>
                        <small>{{item.subtitle}}</small>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list two-line>

                <v-divider></v-divider>
                <v-subheader>SERVICIOS NACIONALES</v-subheader>
                <v-divider></v-divider>
                <v-list-item v-for="(item, index) in servicios_n" v-bind:key="index" :href="item.link" target="_blank">
                     <v-list-item-avatar>
                        <v-img :src="domain+'/'+item.avatar"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title v-html="item.title"></v-list-item-title>
                        <small>{{item.subtitle}}</small>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-container>
    </div>
</template>
<script>
export default {
    data() {
        return {
            servicios_l:[
                //{avatar:'image/servicios/logo.png', title:'MPV', subtitle:'Mesa de Partes Virtual', link:'https://suga.csjpuno.pe'},
                //{avatar:'image/servicios/jurisprudencia.jpg', title:'Jurisprudencia', subtitle:'Buscador de Jurisprudencia', link:'http://jurisprudencia.csjpuno.pe'},
                {avatar:'image/servicios/escjudi.jpg', title:'Certificados', subtitle:'Certificados Escuela Judicial', link:'http://certificados.escuelajudicial.pe'},
            ],
            servicios_n:[
                {avatar:'image/servicios/sinoe.jpg', title:'SINOE', subtitle:'Sistema de Notificaciones Electrónicas', link:'https://casillas.pj.gob.pe/sinoe/login.xhtml'},
                {avatar:'image/servicios/cej.jpg', title:'CEJ', subtitle:'Consulta de Expedientes Judiciales', link:'https://cej.pj.gob.pe/cej/forms/busquedaform.html'},
                {avatar:'image/servicios/odecma.jpg', title:'ODECMA', subtitle:'Oficina Desconcentrada de Control de la Magistratura', link:'http://ocma.pj.gob.pe/'},
                {avatar:'image/servicios/juezescucha.jpg', title:'EL Juez te escucha', subtitle:'Programa tu cita', link:'https://cej.pj.gob.pe/citas/pages/seguridad/login.xhtml'},
                {avatar:'image/servicios/sentidos.jpg', title:'Sentido de decisiones judiciales', subtitle:'', link:'https://gestionsij.pj.gob.pe/sentidoFallo-web/'},
                {avatar:'image/servicios/gob_pe.png', title:'Denuncias Ciudadanas', subtitle:'', link:'https://denuncias.servicios.gob.pe/'},
                {avatar:'image/servicios/libro_reclamaciones.png', title:'Libro de Reclamaciones', subtitle:'', link:'https://www.pj.gob.pe/wps/wcm/connect/cortesuprema/s_cortes_suprema_home/as_servicios/as_enlaces_de_interes/as_libro_de_reclamaciones/libro_reclamaciones_url'},
                {avatar:'image/servicios/logo.png', title:'Oportunidad Laboral', subtitle:'', link:'https://aplicativo.pj.gob.pe/psep/'},
                {avatar:'image/servicios/logo.png', title:'FUT', subtitle:'Formulario Único de Trámite', link:'https://aplicativo.pj.gob.pe/formularioadministrativo/'},
            ],
            domain: ''
        }
    },
    created() {
        this.getDomain();
    },
    methods:{
        getDomain: function () {
            this.domain = location.protocol+'//'+location.host;
        }
    }
}
</script>